/* Sapone di Toscana – welkomstpop-up (10% bij inschrijving op de nieuwsbrief).
 * - Opent ca. 10 seconden na het begin van het bezoek (teller loopt door over pagina's), pas als de cookiemelding weg is
 *   en er geen ander venster open is.
 * - Gesloten: 30 dagen niet opnieuw. Ingeschreven: nooit meer. Opslag alleen functioneel (localStorage, met try/catch).
 * - Na verzenden herlaadt Shopify de pagina; dan tonen we de bedankmelding (alleen als het formulier uit deze pop-up kwam).
 * - Werkt samen met de geuradvies-pop-up (assets/sdt-popup.js): die wacht zolang deze open staat.
 */
(function () {
  'use strict';
  var KEY = 'sdt-welcome';           // 'closed:<timestamp>' of 'subscribed'
  var KEY_SUBMIT = 'sdt-welcome-submitted';
  var SNOOZE = 30 * 24 * 60 * 60 * 1000;
  var DELAY = 10000;                 // ca. 10 seconden na het begin van het bezoek

  function ls(get, val) {
    try { return get ? localStorage.getItem(KEY) : localStorage.setItem(KEY, val); } catch (e) { return null; }
  }
  function ss(key, val) {
    try { if (val === undefined) return sessionStorage.getItem(key); if (val === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, val); } catch (e) { return null; }
  }
  try { if (!sessionStorage.getItem('sdt-visit-start')) sessionStorage.setItem('sdt-visit-start', String(Date.now())); } catch (e) {}

  function isShown(el) {
    if (!el) return false;
    var cs = getComputedStyle(el), r = el.getBoundingClientRect();
    return cs.display !== 'none' && cs.visibility !== 'hidden' && r.width > 0 && r.height > 0;
  }
  function cookieBannerOpen() {
    return isShown(document.getElementById('shopify-pc__banner')) || isShown(document.getElementById('shopify-pc__prefs'));
  }
  function otherDialogOpen(self) {
    var open = document.querySelector('.sdt-popup.is-open');
    if (open && !self.contains(open)) return true;
    return !!document.querySelector('cart-drawer.active, details[open] > .modal__content, .menu-drawer-container[open], modal-dialog[open], .search-modal[open]');
  }

  class SDTWelcomePopup extends HTMLElement {
    connectedCallback() {
      this.popup = this.querySelector('.sdt-popup');
      this.dialog = this.querySelector('.sdt-popup__dialog');
      var self = this;
      var posted = this.dataset.posted === 'true';
      var error = this.dataset.error === 'true';
      var fromHere = ss(KEY_SUBMIT) === '1';
      this.onKey = this.onKey.bind(this);
      this.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      this.popup.addEventListener('click', function (e) { if (e.target === self.popup) self.close(); });
      var form = this.closest('form');
      if (form) form.addEventListener('submit', function () { ss(KEY_SUBMIT, '1'); });

      this.dataset.state = 'done';
      if (posted && !error) {
        ls(false, 'subscribed');
        if (fromHere) { ss(KEY_SUBMIT, null); this.open(); }
        return;
      }
      if (error && fromHere) { ss(KEY_SUBMIT, null); this.open(); return; }

      var design = this.dataset.designMode === 'true';
      var state = ls(true) || '';
      if (!design) {
        if (state === 'subscribed') return;
        if (state.indexOf('closed:') === 0 && Date.now() - parseInt(state.slice(7), 10) < SNOOZE) return;
      }
      this.dataset.state = 'pending'; // de geuradvies-pop-up wacht hierop
      var start = parseInt(ss('sdt-visit-start'), 10) || Date.now();
      var wait = design ? 600 : Math.max(600, DELAY - (Date.now() - start));
      setTimeout(function () { self.tryOpen(0); }, wait);
    }

    tryOpen(attempt) {
      var self = this;
      if (cookieBannerOpen() || otherDialogOpen(this)) {
        if (attempt < 300) setTimeout(function () { self.tryOpen(attempt + 1); }, 1000);
        else this.dataset.state = 'done';
        return;
      }
      this.open();
    }

    open() {
      this.lastFocus = document.activeElement;
      this.popup.hidden = false;
      this.popup.classList.add('is-open');
      this.dataset.state = 'open';
      document.addEventListener('keydown', this.onKey);
      var first = this.querySelector('input[type="email"]') || this.querySelector('[data-popup-close]');
      (first || this.dialog).focus();
    }

    close() {
      this.popup.classList.remove('is-open');
      this.popup.hidden = true;
      this.dataset.state = 'done';
      document.removeEventListener('keydown', this.onKey);
      if (ls(true) !== 'subscribed') ls(false, 'closed:' + Date.now());
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      ss('sdt-popup-last-close', String(Date.now()));
      document.dispatchEvent(new CustomEvent('sdt:popup-closed', { detail: { id: 'welcome' } }));
    }

    onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(this.popup.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  if (!customElements.get('sdt-welcome-popup')) customElements.define('sdt-welcome-popup', SDTWelcomePopup);
})();
